import { authorization, prolongate } from "../actions/CurrentAccount";
import { DOCUMENT_TITLE_POSTFIX, JWTname, localStorageName } from "./constants";

export const setCookie = (name, value, options = {}) => {
    options = {
        path: '/',
        // при необходимости добавить другие значения по умолчанию
        ...options
    };
    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }
    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
    for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }
    document.cookie = updatedCookie;
} 

export const getCookie = (name) => {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([.$?*|{}()[]\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

export const deleteCookie = (name) => {
    setCookie(name, "", {'max-age': -1})
}

/* gtag.js */
export const updateGtmConsent = (event = "default", consent) => { // event = "update" || "default"
    if (typeof window === "undefined" || typeof window.gtag !== "function")
        return

    window.gtag("consent", event, {
        ad_storage: consent.marketing ? "granted" : "denied", // user data for advertising
        ad_user_data: consent.marketing ? "granted" : "denied", // user data for internet-advert
        ad_personalization: consent.marketing ? "granted" : "denied", // analytics data
        analytics_storage: consent.analytics ? "granted" : "denied", // analytics
        personalization_storage: consent.functional ? "granted" : "denied", //так же можно отнести к marketing
        functionality_storage: consent.functional ? "granted" : "denied", // many functions of the site, ex. - language
        security_storage: consent.necessary ? "granted" : "denied", // other methods of security
    })
}


/* JWT token */
export const parseJwt = ( token ) => {
    let split = token.split('.');
	if( split.length !== 3 ) {
		console.log({'Error parse': 'Wrong number of segments'});
	}
    //let headerB64 = split[0];
    let payloadB64Url = split[1];
    //let signB64 = split[2];
	if(null === payloadB64Url) {
		console.log({'Error parse': 'Invalid claims encoding'});
	}
    var payloadB64 = payloadB64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(window.atob(payloadB64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
	//let jsonPayload = urlsafeB64Decode(payloadB64Url);
	return JSON.parse(jsonPayload);
}


export const getUsername = (getName = null) => {
    // получаем данные из локального хранилища и из куков
    if (getCookie(JWTname)) {
        // проверяем валидность токена в куках 
        let cookieJwt = getCookie(JWTname).split('.')
        if (cookieJwt.length === 3) {
            // достаем payload из токена в куках
            let payloadJWT_client = parseJwt(getCookie(JWTname))

            // проверяем, если время жизни токена ушло, данные не отправляем
            if (payloadJWT_client['exp'] > Math.floor(new Date().getTime() / 1000)) {
                if (getName) {
                    return payloadJWT_client['spaUsername'];
                } else 
                    return {'spaUsername': payloadJWT_client['spaUsername'], 'spaId': payloadJWT_client['spaId']}
            } else {
                if (getName) {
                    return null
                } else 
                    return {'spaUsername': null, 'spaId': null}
            }
        } else {
            if (getName) {
                return null
            } else 
                return {'spaUsername': null, 'spaId': null}
        }
    } else {
        if (getName) {
            return null
        } else 
            return {'spaUsername': null, 'spaId': null}
    }
}

export const getUserId = () => {
    // получаем данные из локального хранилища и из куков
    if (getCookie(JWTname)) {
        // проверяем валидность токена в куках 
        let cookieJwt = getCookie(JWTname).split('.')
        if (cookieJwt.length === 3) {
            // достаем payload из токена в куках
            let payloadJWT_client = parseJwt(getCookie(JWTname))

            // проверяем, если время жизни токена ушло, данные не отправляем
            if (payloadJWT_client['exp'] > Math.floor(new Date().getTime() / 1000)) {
                return  payloadJWT_client['spaId']
            } else {
                return null
            }
        } else {
            return null
        }
    } else {
        return null
    }
}

export const getUserRole = () => {
    // получаем данные из локального хранилища и из куков
    if (getCookie(JWTname)) {
        // проверяем валидность токена в куках 
        let cookieJwt = getCookie(JWTname).split('.')
        if (cookieJwt.length === 3) {
            // достаем payload из токена в куках
            let payloadJWT_client = parseJwt(getCookie(JWTname))
            // получаем из jwt данные о роли юзера
            
            // проверяем, если время жизни токена ушло, данные не отправляем
            if (payloadJWT_client['exp'] > Math.floor(new Date().getTime() / 1000)) {
                return payloadJWT_client['role']
            } else {
                return null
            }
        } else {
            return null
        }
    } else {
        return null
    }
}

export const checkTokenIsExp = () => {
    // получаем данные из локального хранилища и из куков
    if (getCookie(JWTname)) {
        // проверяем валидность токена в куках 
        let cookieJwt = getCookie(JWTname).split('.')
        if (cookieJwt.length === 3) {
            // достаем payload из токена в куках
            let payloadJWT_client = parseJwt(getCookie(JWTname))
            // получаем из jwt данные о роли юзера

            // проверяем, если время жизни токена ушло, данные не отправляем
            if (payloadJWT_client['exp'] > Math.floor(new Date().getTime() / 1000)) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    } else {
        return false
    }
}

export const checkAccData = (func) => {
    // получаем данные из локального хранилища и из куков
    if (getCookie(JWTname) && localStorage.getItem(localStorageName)) {
        // проверяем валидность токена в куках 
        let cookieJwt = getCookie(JWTname).split('.')
        if (cookieJwt.length === 3) {
            // достаем payload из токена в куках
            let payloadJWT_client = parseJwt(getCookie(JWTname))
            // toISOString() - 2024-05-19T14:04:11.012Z
            // +new Date() - 1716127573630
            // если валидный и действующий - устанавливаем данные из локалки
            if (payloadJWT_client['exp'] < Math.floor(new Date().getTime() / 1000)) {
                // НЕ действующий - отправляем юзера на prolongate и обновляем токен
                let dataFromLocal = localStorage.getItem(localStorageName);
                let dataFromCookie = getCookie(JWTname);
                let allData = {'from_local': dataFromLocal,'from_cookie': dataFromCookie};

                return prolongate(allData);
            } else {
                // действующий - ничего не делаем с данными
                //datas = JSON.parse(localStorage.getItem(localStorageName))
                return authorization( JSON.parse(localStorage.getItem(localStorageName)) )
            }
        } else {
            return func
        }
    } else {
        return func
    }
}

export const svgImageToBase64 = (svgString) => {
    //let svgString = `<svg width="100" height="100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="40" stroke="black" stroke-width="3" fill="red" /></svg>`; // Замените на ваш SVG код
    let base64String = btoa(svgString);
    let dataUri = `data:image/svg+xml;base64,${base64String}`;

    return dataUri;
}


/* for multi download */
export const delayMulti = milliseconds => new Promise(resolve => {
    setTimeout(resolve, milliseconds);
});
export const downloadMulti = async (url, name) => {
    const a = document.createElement('a');
    a.download = name;
    a.href = url;
    a.style.display = 'none';
    document.body.append(a);
    a.click();

    // Chrome requires the timeout
    await delayMulti(100);
    a.remove();
};
export async function multiDownload(urls, {rename} = {}) {
    if (!urls) {
        throw new Error('`urls` required');
    }

    for (const [index, url] of urls.entries()) {
        const name = typeof rename === 'function' ? rename({url, index, urls}) : '';

        await delayMulti(index * 1000); // eslint-disable-line no-await-in-loop
        downloadMulti(url, name);
    }
}

export const renderCKLicenseKey = () => {
    if (window.__SETTINGS__.debug) {
        return window.__SETTINGS__.CKLicenseKeyDev
    } else {
        return window.__SETTINGS__.CKLicenseKey
    }
}


export const browserNotification = (tag = "alert-settings", body, icon = "https://tankimods.net/faviconn.png") => {
    // Notification on Windows from Browser from our site
    /*Notification.requestPermission()
    .then(permission => {
        if (permission === 'granted') {
            new Notification('TankiMods.Net. Уведомления включены')
        }
    })*/
    if (!("Notification" in window)) {
        // Check if the browser supports notifications
        alert("Этот браузер не поддерживает уведомления на рабочем столе.");
    } else if (Notification.permission === "granted") {
        // Check whether notification permissions have already been granted;
        // if so, create a notification
        //const notification = new Notification("Hi there!");
        // …
        new Notification(DOCUMENT_TITLE_POSTFIX, {
            tag : tag,
            body : body,
            icon : icon
        })
    } else if (Notification.permission !== "denied") {
        // We need to ask the user for permission
        Notification.requestPermission().then((permission) => {
            // If the user accepts, let's create a notification
            if (permission === "granted") {
                //const notification = new Notification("Hi there!");
                // …
                new Notification(DOCUMENT_TITLE_POSTFIX, {
                    tag : tag,
                    body : body,
                    icon : icon
                })
            }
        });
    }
}